import React, { Component } from 'react';
import Container from 'components/v2/container';
import List from './List';

export default class extends Component {
  render() {
    return (
      <Container className="py-8">
        <List />
      </Container>
    );
  }
}
